import { render } from "./cotar-frete-list-dedicada.vue?vue&type=template&id=025e055f"
import script from "./cotar-frete-list-dedicada.vue?vue&type=script&lang=js"
export * from "./cotar-frete-list-dedicada.vue?vue&type=script&lang=js"

import "./cotar-frete-list-dedicada.vue?vue&type=style&index=0&id=025e055f&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__